module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    directives: [{
      name: "async",
      rawName: "v-async",
      value: (_vm.loading),
      expression: "loading"
    }],
    staticClass: "row container"
  }, [_c('div', {
    staticClass: "col-md-4 box-plan",
    staticStyle: {
      "padding": "20px"
    }
  }, [(_vm.recVp === 'N') ? _c('div', {
    staticClass: "alert-warning",
    staticStyle: {
      "background-color": "#fcdec1",
      "margin-bottom": "25px",
      "padding": "20px",
      "margin": "23px",
      "text-align": "left"
    }
  }, [_c('b', [_vm._v("Atenção!")]), _vm._v(" Este plano não recebe Vale-pedágio Eletrônico.\n    ")]) : _vm._e(), _vm._v(" "), _c('p', {
    staticClass: "label-semibold"
  }, [_vm._v("Plano Escolhido:")]), _vm._v(" "), _c('p', {
    staticClass: "title-plan"
  }, [_vm._v(_vm._s(_vm.plan && _vm.plan.name))]), _vm._v(" "), _c('img', {
    staticClass: "choosed-plan-cart",
    attrs: {
      "src": require("../../../assets/img/img-selected-plan.png"),
      "alt": ""
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "col-md-8"
  }, [_c('div', {
    staticClass: "second-col-box"
  }, [_c('b', {
    staticClass: "title-identification"
  }, [_vm._v("Valores do plano")]), _vm._v(" "), (_vm.sameTax) ? _c('div', {
    staticClass: "line-table"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "col-md-6"
  }, [(_vm.newAdhesionTax > 0 && !_vm.promoId) ? _c('h4', {
    staticClass: "label-plan-value"
  }, [_vm._v("\n            " + _vm._s(_vm._f("cents")(_vm.newAdhesionTax)) + "\n          ")]) : _c('h4', {
    staticClass: "label-plan-value"
  }, [_vm._v("GRÁTIS")])])]) : _vm._e(), _vm._v(" "), (!_vm.sameTax) ? _c('div', {
    staticClass: "line-table"
  }, [_vm._m(1), _vm._v(" "), _c('div', {
    staticClass: "col-md-6"
  }, [(_vm.newAdhesionTax > 0 && !_vm.promoId) ? _c('h4', {
    staticClass: "label-plan-value"
  }, [_vm._v("\n            " + _vm._s(_vm._f("cents")(_vm.newAdhesionTax)) + "\n          ")]) : _c('h4', {
    staticClass: "label-plan-value"
  }, [_vm._v("GRÁTIS")])])]) : _vm._e(), _vm._v(" "), (!_vm.sameTax) ? _c('div', {
    staticClass: "line-table"
  }, [_vm._m(2), _vm._v(" "), _c('div', {
    staticClass: "col-md-6"
  }, [(_vm.newVehicleTax > 0) ? _c('h4', {
    staticClass: "label-plan-value"
  }, [_vm._v("\n            " + _vm._s(_vm._f("cents")(_vm.newVehicleTax)) + "\n          ")]) : _c('h4', {
    staticClass: "label-plan-value"
  }, [_vm._v("GRÁTIS")])])]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "line-table-striped"
  }, [_c('div', {
    staticClass: "col-md-6"
  }, [_c('div', {
    staticClass: "label-plan"
  }, [_vm._v("Carga inicial:")]), _vm._v(" "), (_vm.planId == 32) ? _c('p', {
    staticClass: "label-first-charge margin-b0"
  }, [_vm._v("\n            Será o valor da recarga inicial, obrigatória na adesão e sempre\n            que houver a necessidade de uma recarga\n          ")]) : _c('p', {
    staticClass: "label-first-charge margin-b0"
  }, [_vm._v("\n            (É necessário no ato da adesão realizar uma carga inicial)\n          ")])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-6"
  }, [_c('dropdown', {
    staticClass: "dropdown-recharge",
    attrs: {
      "options": _vm.rechargesData,
      "value": _vm.value
    },
    on: {
      "itemSelected": _vm.changeRecharge,
      "change": function($event) {
        _vm.selectedValue = _vm.value
      }
    },
    model: {
      value: (_vm.value),
      callback: function($$v) {
        _vm.value = $$v
      },
      expression: "value"
    }
  }, [_vm._v("\n            >\n          ")]), _vm._v(" "), (_vm.value == -1) ? _c('div', {
    staticClass: "form-group",
    class: {
      'has-error': _vm.errors.has('valueTotal')
    }
  }, [_c('input', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: (
        'required|recargaMinima:' + _vm.minValue + '|isMultiple:5000'
      ),
      expression: "\n                'required|recargaMinima:' + minValue + '|isMultiple:5000'\n              "
    }],
    staticClass: "form-control text-right input-recharge",
    attrs: {
      "id": "valueTotal",
      "type": "text",
      "name": "valueTotal",
      "placeholder": "R$ 00,00",
      "spellcheck": "false",
      "autocomplete": "off",
      "autocorrect": "off",
      "autocapitalize": "off",
      "maxlength": "14"
    },
    domProps: {
      "value": _vm.valueFormatted
    },
    on: {
      "input": function($event) {
        return _vm.setTotal($event.target.value)
      }
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "help-block help-block-recharge with-errors"
  }, [_vm._v("\n              " + _vm._s(_vm.errors.first("valueTotal")) + "\n            ")])]) : _vm._e()], 1)]), _vm._v(" "), _c('div', {
    staticClass: "row row-fix",
    class: {
      'tax-value-only': !_vm.monthlyTax
    }
  }, [_c('div', {}, [_vm._m(3), _vm._v(" "), _c('div', {
    staticClass: "col-md-6"
  }, [_c('h4', {
    staticClass: "label-plan-value"
  }, [_vm._v(_vm._s(_vm._f("cents")(_vm.tax)))])])])]), _vm._v(" "), (_vm.planId == 31 || _vm.planId == 32) ? _c('div', {
    staticClass: "line-table padding-17"
  }, [_vm._m(4), _vm._v(" "), _c('div', {
    staticClass: "col-md-6"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.changeFlagEmail),
      expression: "changeFlagEmail"
    }],
    attrs: {
      "type": "radio",
      "name": "email",
      "value": "1"
    },
    domProps: {
      "checked": _vm._q(_vm.changeFlagEmail, "1")
    },
    on: {
      "change": function($event) {
        _vm.changeFlagEmail = "1"
      }
    }
  }), _vm._v("\n          Sim"), _c('br'), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.changeFlagEmail),
      expression: "changeFlagEmail"
    }],
    attrs: {
      "type": "radio",
      "name": "email",
      "value": "0"
    },
    domProps: {
      "checked": _vm._q(_vm.changeFlagEmail, "0")
    },
    on: {
      "change": function($event) {
        _vm.changeFlagEmail = "0"
      }
    }
  }), _vm._v("\n          Não\n        ")])]) : _vm._e(), _vm._v(" "), (_vm.monthlyTax) ? _c('div', {
    staticClass: "row row-fix"
  }, [_c('div', {
    staticClass: "label-monthly-value"
  }, [_vm._m(5), _vm._v(" "), _c('div', {
    staticClass: "col-md-6"
  }, [_c('h4', {
    staticClass: "label-plan-value"
  }, [_vm._v(_vm._s(_vm._f("cents")(_vm.monthlyTax)))])])])]) : _vm._e(), _vm._v(" "), (_vm.planId == 31) ? _c('div', [_c('div', {
    staticClass: "line-table-white"
  }, [_c('div', {
    staticClass: "col-md-6"
  }, [(_vm.planId == 31) ? _c('div', {
    staticClass: "label-plan"
  }, [_vm._v("\n              Quero ser avisado quando meu saldo atingir o valor de:\n              " + _vm._s(_vm.limiteFormatado()) + "\n            ")]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-6"
  }, [_c('div', {
    staticClass: "fleet-switch"
  }, [_c('div', {
    staticClass: "onoffswitch"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.contract.lcFlag),
      expression: "contract.lcFlag"
    }],
    staticClass: "onoffswitch-checkbox",
    attrs: {
      "type": "checkbox",
      "id": "round-switch"
    },
    domProps: {
      "checked": Array.isArray(_vm.contract.lcFlag) ? _vm._i(_vm.contract.lcFlag, null) > -1 : (_vm.contract.lcFlag)
    },
    on: {
      "change": function($event) {
        var $$a = _vm.contract.lcFlag,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.$set(_vm.contract, "lcFlag", $$a.concat([$$v])))
          } else {
            $$i > -1 && (_vm.$set(_vm.contract, "lcFlag", $$a.slice(0, $$i).concat($$a.slice($$i + 1))))
          }
        } else {
          _vm.$set(_vm.contract, "lcFlag", $$c)
        }
      }
    }
  }), _vm._v(" "), _vm._m(6)])])])])])]) : (_vm.planId == 32) ? _c('div', [_c('div', {
    staticClass: "line-table-white"
  })]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "line-table-striped"
  }, [_vm._m(7), _vm._v(" "), _c('div', {
    staticClass: "col-md-6 coupon-container"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.coupon),
      expression: "coupon"
    }],
    staticClass: "form-control input-coupon",
    attrs: {
      "type": "text",
      "name": "coupon",
      "placeholder": "Digite o código",
      "maxlength": "50"
    },
    domProps: {
      "value": (_vm.coupon)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.coupon = $event.target.value
      }
    }
  })])])]), _vm._v(" "), _vm._m(8)])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-md-6"
  }, [_c('p', {
    staticClass: "label-plan"
  }, [_vm._v("Adesão por veículo (TAG)"), _c('sup', [_vm._v("1")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-md-6"
  }, [_c('p', {
    staticClass: "label-plan"
  }, [_vm._v("Adesão por veículo (TAG)"), _c('sup', [_vm._v("1")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-md-6"
  }, [_c('p', {
    staticClass: "label-plan"
  }, [_vm._v("Adesão por veículo (TAG)"), _c('sup', [_vm._v("1")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-md-6"
  }, [_c('p', {
    staticClass: "label-plan"
  }, [_vm._v("Taxa de Recarga"), _c('sup', [_vm._v("2")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-md-6"
  }, [_c('p', {
    staticClass: "label-plan"
  }, [_vm._v("\n            Deseja receber fatura de conferência por e-mail?\n          ")]), _vm._v(" "), _c('p', {
    staticClass: "label-first-charge"
  }, [_vm._v("\n            Se sim, enviaremos no 1º dia de cada mês a fatura para conferência\n            referente à utilização do mês anterior.\n          ")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-md-6"
  }, [_c('p', {
    staticClass: "label-plan"
  }, [_vm._v("Mensalidade:")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('label', {
    staticClass: "onoffswitch-label",
    staticStyle: {
      "text-align": "left"
    },
    attrs: {
      "for": "round-switch"
    }
  }, [_c('span', {
    staticClass: "onoffswitch-inner"
  }), _vm._v(" "), _c('span', {
    staticClass: "onoffswitch-switch"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-md-6"
  }, [_c('div', {
    staticClass: "label-plan"
  }, [_vm._v("Código do Vendedor:")]), _vm._v(" "), _c('p', {
    staticClass: "label-first-charge"
  }, [_vm._v("\n            (Opcional) Informe o código se possuir\n          ")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('p', [_vm._v("\n        ¹ ² As condições promocionais estão sujeitas às regras de cada\n        campanha vigente.\n        "), _c('a', {
    staticStyle: {
      "text-decoration": "underline"
    },
    attrs: {
      "href": "https://movemais.com/api/v2/archeion/downloadFileArcheion/regulamento-promocional-movemais",
      "target": "_blank",
      "rel": "noopener noreferrer"
    }
  }, [_vm._v("\n          Consulte o regulamento")]), _vm._v(".\n      ")])])
}]}


//////////////////
// WEBPACK FOOTER
// C:/Users/enzo.barros/software/azure/movemais.client/~/vue-loader/lib/template-compiler.js?id=data-v-f27ceba4!C:/Users/enzo.barros/software/azure/movemais.client/~/vue-loader/lib/selector.js?type=template&index=0!./src/pages/common/adhesion/choose-recharge.vue
// module id = 2225
// module chunks = 1